var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Variables")]),_c('div',{attrs:{"id":"jsoneditor"}}),_c('b-button',{on:{"click":_vm.update}},[_vm._v("Mettre à jour")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }